import React from 'react';
import PropTypes from 'prop-types';

export const Ibd2022Layout = ({ children, sublayout }) => {
  return (
    <div
      id="InnovationByDesign__2022"
      className={`${sublayout ? sublayout : ''}`}
    >
      {children}
    </div>
  )
};

Ibd2022Layout.propTypes = {
  children: PropTypes.any
}